module.exports = __webpack_public_path__ + "static/media/ibuzz.6efae145.svg";